module.exports = __webpack_public_path__ + "static/media/HDFCBANK.fa685ed7.txt";